export default class NewsAudio {
    //NEWS AUDIO PLAYER FUNCTIONALITY
    //document.addEventListener('DOMContentLoaded', function () {
    public static init() {
        let timeline = <HTMLInputElement>document.querySelector('.timeline');
        let audio = document.querySelector('.player audio') as HTMLAudioElement;
        let playerButton = <HTMLButtonElement>document.querySelector('#player-play-button');
        let forwardButton = <HTMLButtonElement>document.querySelector('#player_forward');
        let backwardButton = <HTMLButtonElement>document.querySelector('#player_backward');
        let durationElement = <HTMLSpanElement>document.querySelector('#duration');
        let currentTimeElement = <HTMLSpanElement>document.querySelector('#current-time');
        let volumeButton = <HTMLSpanElement>document.querySelector('#volume-btn');
        let volumeBox = <HTMLDivElement>document.querySelector('#volume-box');
        let volumeLabel = <HTMLDivElement>document.querySelector('#volume-level-label');
        let playbackRateElement = <HTMLSpanElement>document.querySelector('#playback-rate');
        let playbackRateBoxElement = <HTMLDivElement>document.querySelector('#playback-rate-box');
        let speedZeroButton = <HTMLButtonElement>document.querySelector('#speed-zero');
        let speedP1Button = <HTMLButtonElement>document.querySelector('#speed-p1');
        let speedP2Button = <HTMLButtonElement>document.querySelector('#speed-p2');
        let speedP3Button = <HTMLButtonElement>document.querySelector('#speed-p3');
        let speedM1Button = <HTMLButtonElement>document.querySelector('#speed-m1');
        let speedM2Button = <HTMLButtonElement>document.querySelector('#speed-m2');
        let speedButtonsArray = [];
        let volumeBarsArray = [];
        let currentVolumeLevel = 10;
        const animBump = [
            // { transform: 'scale(1) ', backgroundColor: 'transparent', borderRadius: '50%' },
            // { transform: 'scale(0.8)', backgroundColor: '#EE2850', borderRadius: '50%' },
            // { transform: 'scale(1)', backgroundColor: 'transparent', borderRadius: '50%' }
            { transform: 'scale(1) ' },
            { transform: 'scale(0.8)' },
            { transform: 'scale(1)' }
        ];

        const animBwd = [
            { transform: 'Rotate(0) scale(1)' },
            { transform: 'Rotate(-30deg) scale(1.2)' },
            { transform: 'Rotate(0) scale(1)' }
        ];

        const animFwd = [
            { transform: 'Rotate(0) scale(1)' },
            { transform: 'Rotate(30deg) scale(1.2)' },
            { transform: 'Rotate(0) scale(1)' }
        ];

        const animScUp = [
            { transform: 'scale(1)' },
            { transform: 'scale(1.1)' },
            { transform: 'scale(1)' }
        ];

        const animOpt = {
            duration: 300,
            iterations: 1,
        }
        if (timeline && audio && playerButton && durationElement && currentTimeElement) {
            for (let i = 0; i <= 10; i++) {
                let el = <HTMLDivElement>document.querySelector('#vbar-' + i);
                el.onmouseenter = () => fillVolumeBars(el);
                el.onclick = () => setVolumeLevel(i);
                volumeBarsArray.push(el);
            }
            playerButton.addEventListener('click', toggleAudio);
            forwardButton.addEventListener('click', () => { skipTime(20) });
            backwardButton.addEventListener('click', () => { skipTime(-20) });
            speedZeroButton.addEventListener('click', () => { changeSpeedTo(1, speedZeroButton) });
            speedP1Button.addEventListener('click', () => { changeSpeedTo(1.2, speedP1Button) });
            speedP2Button.addEventListener('click', () => { changeSpeedTo(1.5, speedP2Button) });
            speedP3Button.addEventListener('click', () => { changeSpeedTo(2, speedP3Button) });
            speedM1Button.addEventListener('click', () => { changeSpeedTo(0.8, speedM1Button) });
            speedM2Button.addEventListener('click', () => { changeSpeedTo(0.5, speedM2Button) });
            volumeButton.onmouseenter = showVolumeBox;
            volumeButton.onmouseleave = hideVolumeBox;
            volumeButton.onclick = toggleVolume;
            volumeBox.onmouseenter = showVolumeBox;
            volumeBox.onmouseleave = hideVolumeBox;
            forwardButton.onmouseenter = () => { forwardButton.animate(animScUp, animOpt) };
            forwardButton.onmouseleave = () => { forwardButton.animate(animScUp, animOpt) };
            backwardButton.onmouseenter = () => { backwardButton.animate(animScUp, animOpt) };
            backwardButton.onmouseleave = () => { backwardButton.animate(animScUp, animOpt) };
            speedButtonsArray.push(speedZeroButton, speedP1Button, speedP2Button, speedP3Button, speedM1Button, speedM2Button);
            playbackRateElement.addEventListener('click', togglePlaybackRateBox);
            audio.onended = audioEnded;
            audio.ontimeupdate = changeTimelinePosition;
            timeline.addEventListener('input', changeSeek);
            displayAudioDuration();
            audio.addEventListener('durationchange', (event) => { displayAudioDuration(); });

        };

        function toggleVolume() {
            if (audio.volume == 0) {
                volumeButton.classList.remove('disabled');
                setVolumeLevel(10);
            }
            else {
                volumeButton.classList.add('disabled');
                setVolumeLevel(0);
            }
        }

        function setVolumeLevel(level) {
            currentVolumeLevel = Math.round(level);
            volumeLabel.textContent = currentVolumeLevel.toString();
            audio.volume = currentVolumeLevel / 10;
            fillVolumeBars(volumeBarsArray[level]);
            hideVolumeBox();
            if (audio.volume == 0) volumeButton.classList.add('disabled'); else volumeButton.classList.remove('disabled');
        }

        function fillVolumeBars(bar) {
            volumeLabel.textContent = volumeBarsArray.indexOf(bar).toString();
            let found = false;
            volumeBarsArray.forEach(element => {
                if (!found) {
                    if (!element.classList.contains('filled'))
                        element.classList.add('filled');
                } else {
                    if (element.classList.contains('filled'))
                        element.classList.remove('filled');
                }
                if (bar == element) found = true;
            }
            );
        }

        function hideVolumeBox() {
            if (!volumeBox.classList.contains('vis-hidden'))
                volumeBox.classList.add('vis-hidden');
            if (volumeButton.classList.contains('hovered'))
                volumeButton.classList.remove('hovered');
        };

        function showVolumeBox() {
            setVolumeLevel(audio.volume * 10);
            if (volumeBox.classList.contains('vis-hidden'))
                volumeBox.classList.remove('vis-hidden');
            if (!volumeButton.classList.contains('hovered'))
                volumeButton.classList.add('hovered');
        };

        function togglePlaybackRateBox() {
            if (playbackRateBoxElement.classList.contains('hidden'))
                playbackRateBoxElement.classList.remove('hidden')
            else playbackRateBoxElement.classList.add('hidden');
        };

        function changeSpeedTo(speed, self) {
            audio.playbackRate = speed;
            speedButtonsArray.forEach(element => {
                element.classList.remove('current-speed');
            });
            self.classList.add('current-speed');
            togglePlaybackRateBox();
            playbackRateElement.textContent = speed + 'x';
        }

        function calculateTime(secs: number) {
            let minutes = Math.floor(secs / 60);
            let seconds = Math.floor(secs % 60);
            let returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
            return `${minutes}:${returnedSeconds}`;
        }

        function displayAudioDuration() {
            if (audio.duration)
                durationElement.textContent = calculateTime(audio.duration);
        };

        function toggleAudio() {
            if (audio.paused) {
                audio.play();
                gtag('event', 'embeded_player_play', {
                'embeded_player_url': audio.currentSrc,
                'embeded_player_type': 'playback_start_initiated'
                });
                playerButton.classList.remove('play-icon');
                playerButton.classList.add('pause-icon');
            } else {
                audio.pause();
                playerButton.classList.add('play-icon');
                playerButton.classList.remove('pause-icon');
            }
            playerButton.animate(animBump, animOpt);
        }
        function audioEnded() {
            playerButton.classList.add('play-icon');
            playerButton.classList.remove('pause-icon');
        }

        function changeTimelinePosition() {
            const percentagePosition = (10000 * audio.currentTime) / audio.duration;
            timeline.value = percentagePosition.toString();
            currentTimeElement.textContent = calculateTime(audio.currentTime);
        }
        function changeSeek() {
            const time = (Number(timeline.value) * audio.duration) / 10000;
            audio.currentTime = time;
        }
        function skipTime(value: number) {
            audio.currentTime += value;
            if (value > 0) {
                forwardButton.animate(animFwd, animOpt);
            } else {
                backwardButton.animate(animBwd, animOpt);
            }
        }
    }
    //});
    //END OF NEWS AUDIO PLAYER FUNCTIONALITY
}